export const Paths = {
  VALIDATE: '/validate/:token',
  CHECKOUT: '/checkout/payment',
  SHOPIFY_STATUS: '/checkout/shopify/:token/success',
  REDIRET_PARENT: '/checkout',
  NOT_FOUND: '/',
};
